/**
 * Account-settings enumerations shared by both platforms.
 *
 * The privacy ids come from the backend; the display strings are the values
 * ProfileContext keeps on the cached profile.
 */

export const PROFILE_VISIBILITY_ID = {
  public: 1,
  buddies: 2,
  private: 3,
} as const;

export const WEIGHT_VISIBILITY_ID = {
  public: 1,
  buddies: 2,
  onlyMe: 3,
} as const;

export type ProfileVisibilityKey = keyof typeof PROFILE_VISIBILITY_ID;
export type WeightVisibilityKey = keyof typeof WEIGHT_VISIBILITY_ID;

export const PROFILE_VISIBILITY_KEYS = Object.keys(
  PROFILE_VISIBILITY_ID,
) as ProfileVisibilityKey[];

export const WEIGHT_VISIBILITY_KEYS = Object.keys(
  WEIGHT_VISIBILITY_ID,
) as WeightVisibilityKey[];

/** Labels the cached profile stores for these settings. */
export const PROFILE_VISIBILITY_LABEL: Record<ProfileVisibilityKey, string> = {
  public: 'Public',
  buddies: 'Buddies only',
  private: 'Private',
};

export const WEIGHT_VISIBILITY_LABEL: Record<WeightVisibilityKey, string> = {
  public: 'Public',
  buddies: 'Buddies only',
  onlyMe: 'Only me',
};

export const profileVisibilityKeyFromId = (
  id?: number | null,
): ProfileVisibilityKey =>
  PROFILE_VISIBILITY_KEYS.find(key => PROFILE_VISIBILITY_ID[key] === id) ?? 'public';

export const weightVisibilityKeyFromId = (
  id?: number | null,
): WeightVisibilityKey =>
  WEIGHT_VISIBILITY_KEYS.find(key => WEIGHT_VISIBILITY_ID[key] === id) ?? 'public';
